import { cloneDeep } from 'lodash';
import { Component } from '@angular/core';
import { ExterneAppsFacadeService } from '@app/municipality-management/services/externe-apps-facade.service';
import { FeaturePermission } from '@app/shared/services/api/permission.service';
import { MunicipalityManagementConfigurationStore } from '@app/municipality-management/services/municipality-management-configuration.store';
import { MunicipalityManagementQueueStateService, LinkAction, PermissionType } from '../../../services/municipality-management-queue-state.service';
import { map } from 'rxjs';
import { AuthService } from '@app/shared/services/auth.service';
import { PermissionStatusCode } from './../../../models/externe-apps';

@Component({
  selector: 'app-externe-apps-activation-tab',
  templateUrl: './externe-apps-activation-tab.component.html',
  styleUrls: ['./externe-apps-activation-tab.component.scss'],
})
export class ExterneAppsActivationTabComponent {
  public municipalityDeactivated$ = this._configStore.municipalityConfig$.pipe(map((config) => config.isDeactivated));
  private selectedFeaturePermission: FeaturePermission | null = null;

  constructor(
    private _configStore: MunicipalityManagementConfigurationStore,
    public externeAppsFacadeService: ExterneAppsFacadeService,
    private _municipalityManagementQueueStateService: MunicipalityManagementQueueStateService,
    private authService: AuthService
  ) {
    this.externeAppsFacadeService.externeAppsIconDispatch();
  }

  public addExterneApp(): void {
    this.externeAppsFacadeService.addExterneApp();
  }

  public menuOpened(row: FeaturePermission): void {
    this.selectedFeaturePermission = cloneDeep(row);
  }

  public menuClosed(): void {
    this.selectedFeaturePermission = null;
  }

  public editExterneApp(): void {
    if (this.selectedFeaturePermission) {
      this.externeAppsFacadeService.editExterneApp(this.selectedFeaturePermission);
    }
  }

  public deleteExterneApp(): void {
    if (this.selectedFeaturePermission && this.authService.permissions.GENERAL_CONFIGURATION) {
      this.externeAppsFacadeService.deleteExterneApp(this.selectedFeaturePermission);
    }
  }

  public changeExternalLink(featurePermission: FeaturePermission, value: string): void {
    if (featurePermission.municipalityPermissionsMappings?.length > 0) {
      this._municipalityManagementQueueStateService.addLinktoQueue(featurePermission, value, LinkAction.UPDATE);
    } else {
      this._municipalityManagementQueueStateService.addLinktoQueue(featurePermission, value, LinkAction.ADD);
    }
    featurePermission.externeAppsStatus = this.externeAppsFacadeService.updateExterneAppStatus(
      featurePermission.externeAppsStatus || [],
      false,
      value?.length > 0
    );
    this.externeAppsFacadeService.updateExterneLink(featurePermission.guid, value);
  }

  public selectStatus(statusCode: PermissionStatusCode, featurePermission: FeaturePermission): void {
    this._municipalityManagementQueueStateService.addStatustoQueue(statusCode, featurePermission, PermissionType.CUSTOM);
  }
}
